export default function InputCompteur( compteur ) {

	const input = document.querySelector( `#${compteur.dataset.input}` );
	const nbMax = compteur.dataset.max;
	const hint = compteur.querySelector( 'span' );
	const status = compteur.nextElementSibling;
	let searchtimer;

	function updateStatus( length ){
		status.innerHTML = `${length} sur ${nbMax} caractères.`;
	};

	input.addEventListener( 'input', function () {
		let length = input.value.length;

		hint.innerHTML = `${length}`;
		if ( length > nbMax ) {
			input.setAttribute( 'aria-invalid', true );
		} else {
			input.setAttribute( 'aria-invalid', false );
		}

		clearTimeout(searchtimer); // <--- The solution is here
    searchtimer = setTimeout(() => {
			updateStatus(length);
		}, 1000 );
		

	} );


}